import { HttpClient } from '@angular/common/http'
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { filter } from 'rxjs/operators'
import { ResponseUSer } from './_models'
import { AuthenticationService } from './_services'
import { FontServiceService } from './_services/font-service.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  rrr = ''
  title = 'ParkingSpaces'
  currentUser: ResponseUSer
  viewMenu = false
  mySubscription: any
  cabove: any
  cbelow: any
  selected: any
  idx = 0
  pairs = [
    { header: 'Oswald', body: 'EB Garamond' },
    { header: 'Oswald', body: 'Cardo' },
    { header: 'Open Sans', body: 'Open Sans Condensed' },
    { header: 'Raleway', body: 'Roboto Slab' },
    { header: 'Roboto', body: 'Roboto Condensed' },
    { header: 'Playfair Display', body: 'Source Sans Pro' },
    { header: 'Playfair Display', body: 'Chivo' },
    { header: 'Alegreya', body: 'Lato' },
    { header: 'Fjalla One', body: 'Noto Sans' },
    { header: 'PT Sans', body: 'PT Sans Narrow' },
    { header: 'Josefin Sans', body: 'Amatic SC' },
    { header: 'Merriweather', body: 'Montserrat' },
    {
      header: 'Quicksand',
      hstyle: 'medium',
      body: 'Quickand',
      bstyle: 'light'
    },
    { header: 'Archivo Black', body: 'Judson' },
    { header: 'Crimson Text', body: 'Work Sans' },
    { header: 'Abril Fatface', body: 'Roboto', bstyle: 'light' },
    { header: 'Archivo', hstyle: 'medium', body: 'Open Sans', bstyle: 'light' },
    { header: 'Montserrat', body: 'Work Sans' },
    { header: 'Montserrat', body: 'Lora' },
    { header: 'Prata', body: 'Lato' }
  ]
  constructor (
    private router: Router,
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    private fontService: FontServiceService
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(events => {
        this.authenticationService.currentUser.subscribe(
          x => (this.currentUser = x)
        )
      })
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false
    }
    this.mySubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false
      }
    })
  }
  ngAfterViewInit (): void {
    var estilofuente = localStorage.getItem('estilofuente')

    if (
      estilofuente == null ||
      estilofuente == undefined ||
      estilofuente == ''
    ) {
      this.idx = 3
      this.selected = this.pairs[this.idx]
      localStorage.setItem('coabove', '#1876F3')
      localStorage.setItem('cobelow', '#2E3740')
      console.log(this.pairs[this.idx], 'jj')
      localStorage.setItem('estilofuente', this.selected)

      //  this.setPair();
    } else {
      this.selected = this.pairs[estilofuente]

      console.log(this.pairs[estilofuente], 'weee')
      this.fontService.loadFont(this.pairs[estilofuente])
    }
  }

  setPair () {
    this.selected = this.pairs[this.idx]

    this.fontService.loadFont(this.selected)

    try {
      var color = localStorage.getItem('coabove')
      this.rrr =
        '{ margin: 0; font-family: ' + this.selected.body + ' !important; }'
    } catch (error) {}
  }

  onClick (n: number) {
    this.idx
    if (this.idx + n < 0) {
      this.idx = this.pairs.length - 1
    } else if (this.idx + n > this.pairs.length - 1) {
      this.idx = 0
    } else {
      this.idx += n
    }
    this.setPair()
  }
  ngOnDestroy (): void {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe()
    }
  }
  ngOnInit () {
    if (this.authenticationService.currentUserValue) {
      var element = document.getElementById('fondo')

      element.classList.remove('fondo')
      var estilofuente = localStorage.getItem('estilofuente')

      try {
        if (
          estilofuente == null ||
          estilofuente == undefined ||
          estilofuente == ''
        ) {
          this.idx = 3
          localStorage.setItem('coabove', '#1876F3')

          localStorage.setItem('cobelow', '#2E3740')
          localStorage.setItem('estilofuente', String(this.idx))
          document.getElementById('fondo').style.color = '#2E3740'
          document.getElementById('toolbar').style.background = '#1876F3'
          this.setPair()
        } else {
          this.idx = Number(estilofuente)
          var color = localStorage.getItem('coabove')
          var colorLetra = localStorage.getItem('cobelow')
          document.getElementById('fondo').style.color = colorLetra || '#2E3740'
          document.getElementById('toolbar').style.background =
            color || '#1876F3'
          this.setPair()
        }
      } catch (error) {}
    }
  }
  logout () {
    this.authenticationService.logout()
  }
  OnViewMenu () {
    this.viewMenu = false
  }
  OnViewMenuActivate () {
    this.viewMenu = true
  }
  OnPerfil () {
    window.location.replace('/perfil')
  }
}
